// Ref: https://github.com/baianat/vee-validate/blob/3b0fcb6e6814ced57c5aa69156b50fc3f267c62e/src/rules/decimal.js
function getMessage(field, [decimals = '*'] = []) {
  return `The ${field} field must be numeric and may contain ${!decimals || decimals === '*' ? '' : decimals} decimal points.`
}

function validate(value, [decimals = '*', separator = '.'] = []) {
  if (Array.isArray(value)) {
    return value.every(val => this.validate(val, [decimals, separator]))
  }

  if (value === null || value === undefined || value === '') {
    return true
  }

  // Remove thousand seperator
  value = '' + value // If a format other den str, it doesnt has replace
  const valueWithoutMask = value.replace(/,/g, '')

  // if is 0.
  if (Number(decimals) === 0) {
    return /^-?\d*$/.test(valueWithoutMask)
  }

  const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`
  const regex = new RegExp(`^-?\\d*(\\${separator}\\d${regexPart})?$`)

  if (!regex.test(valueWithoutMask)) {
    return false
  }

  const parsedValue = parseFloat(valueWithoutMask)

  // eslint-disable-next-line
  return parsedValue === parsedValue
}

export default {
  getMessage,
  validate
}
